import React from 'react';

function Privacy() {
  return (
    <>
      <h1>Privacy</h1>

      <p>
        This website is owned and operated by The Baltimore Life Companies*. You may forward any
        correspondence to the following postal address: 10075 Red Run Boulevard, Owings Mills,
        Maryland 21117-4871. You may also telephone us at (800) 628-5433, or e-mail us.
      </p>
      <p>
        We recognize that many visitors to our site are concerned about the information they provide
        to us and how we treat that information. To answer these concerns, we have developed the
        following Privacy Policy. Please note that this Policy may be updated from time to time.
      </p>
      <p>
        <strong>Our Policy</strong>
        <br />
        Personally-identifiable information from individuals is not collected by this web site
        unless the user provides it to us voluntarily and knowingly. This means you do not have to
        provide any personal information to us before viewing our public site. However, if you
        participate in any giveaway promotion through use of our web site, and complete the request
        form, you specifically agree to be contacted by us and placed on our mailing list. As such,
        we may contact you from time to time.
      </p>
      <p>
        <strong>Cookies</strong>
        <br />
        Many companies use "cookie" technology on their web sites. Baltimore Life also takes
        advantage of this technology. Cookies are small electronic files stored on your computer by
        your browser. When you visit our web site, the cookie tells us whether you are a new visitor
        or whether you have visited us in the past. Cookies do not obtain any personal information
        about you or provide us with any way to contact you, and the cookie does not extract any
        information from your computer. We do use the cookie to help us identify site features in
        which you have the greatest interest. This data will help us provide better site content and
        layout.
      </p>
      <p>
        <strong>Third-Party Information Sharing</strong>
        All personal information that you voluntarily supply to us through this web site is treated
        with the utmost confidentiality. Baltimore Life does not share this information with anyone
        outside of our company.
      </p>

      <p>
        <strong>Social Security Number Privacy Protection Policy</strong>
        Baltimore Life strives to protect the security and confidentiality of Social Security
        numbers that we obtain in the course of business. We limit access to Social Security numbers
        and maintain strong security controls that are designed to safeguard Social Security numbers
        from unlawful disclosure.
      </p>

      <p>
        * The Baltimore Life Companies consist of The Baltimore Life Insurance Company and Baltimore
        Financial Brokerage, Inc.
      </p>
    </>
  );
}

export { Privacy };
